export const environment = {
  production: true,
  envApi: 'https://shop-quoting-tool.coverme.gov',
  cataract_api: 'http://localhost:3001/' // update this later. fixing for build
};
